import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Btn, Rule } from '../Common/OkoylUI';

const FinalizeCharacter = ({ character, onBack, onSubmit }) => {
    const { t } = useTranslation();
    const name = character.name || t('characterCreation.step4.fallbackName');

    return (
        <div style={{ textAlign: 'center', padding: '24px 8px' }}>
            <h2 className="okcard-title" style={{ marginBottom: 8 }}>{t('characterCreation.step4.title')}</h2>
            <Rule thin />

            <div style={{ marginTop: 16, fontFamily: 'var(--font-display)', fontSize: 28, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--okoyl-200)' }}>
                {name}
            </div>

            <p className="oklore" style={{ marginTop: 18, maxWidth: 520, marginLeft: 'auto', marginRight: 'auto' }}>
                {t('characterCreation.step4.lore')}
            </p>

            <div style={{ marginTop: 24, fontFamily: 'var(--font-body)', fontSize: 13, color: 'var(--ash-300)', maxWidth: 520, marginLeft: 'auto', marginRight: 'auto' }}>
                <Trans i18nKey="characterCreation.step4.objective">
                    Le simple objectif : ne pas mourir. Si vous atteignez <strong style={{ color: 'var(--okoyl-200)' }}>le niveau 5</strong>, le récit s'ouvrira davantage.
                </Trans>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, marginTop: 32 }}>
                <Btn variant="primary" onClick={onSubmit}>
                    {t('characterCreation.step4.submit')}
                </Btn>
                <Btn variant="ghost" small onClick={onBack}>
                    ◀ {t('common.back')}
                </Btn>
            </div>
        </div>
    );
};

export default FinalizeCharacter;
